import stringFormatService from '../../services/stringFormatService';
import {config} from '../config';
import configGettersService from './configGettersService';

const getDcsSupportUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.dcsSupportUrl);
const getIqosHomeUrl = () => configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.iqosHomeUrl);
const getIqosStoreUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.iqosStoreUrl);
const getFooterCompanyInfoUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.footerCompanyInfoUrl);
const getFooterUserLicenseUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.footerUserLicenseUrl);
const getFooterPrivacyNoticeUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.footerPrivacyNoticeUrl);

export default {
    getDcsSupportUrlFormatted: () => stringFormatService.getLanguageFormattedString(getDcsSupportUrl()),
    getIqosHomeUrlFormatted: () => stringFormatService.getLanguageFormattedString(getIqosHomeUrl()),
    getIqosStoreUrlFormatted: () => stringFormatService.getLanguageFormattedString(getIqosStoreUrl()),
    getFooterCompanyInfoUrlFormatted: () => stringFormatService.getLanguageFormattedString(getFooterCompanyInfoUrl()),
    getFooterUserLicenseUrlFormatted: () => stringFormatService.getLanguageFormattedString(getFooterUserLicenseUrl()),
    getFooterPrivacyNoticeUrlFormatted: () =>
        stringFormatService.getLanguageFormattedString(getFooterPrivacyNoticeUrl()),
};
